<template>
    <div class="index">
        <div class="index-cont">
            <!-- 左侧 -->
            <div class="index-1">
                <div class="border-left-1" @mouseover="changIconsBlockPosition('enter', 1)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index">
                                <p class="cont-top-bg">客户数据</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsFir" @chooseData="childByValue" class="cont-position"
                                        :timeArray="timerData" :infoTitle="'客户数据'" @download="download" :idName="idName1"
                                        :stringPaintChart="childByValue" @changeTextColor="changeTextColor"
                                        :details="COUNSTDATE.CUSTOMER_DATA" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 80%">
                                <div id="myChart" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="border-left-2" @mouseover="changIconsBlockPosition('enter', 2)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index">
                                <p class="cont-top-bg">人选推荐</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsSec" class="cont-position" :timeArray="timerData"
                                        @chooseData="childByValue" :infoTitle="'人选推荐'" @download="download"
                                        :idName="idName2" :stringPaintChart="childByValue"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.RECOMMEND" />
                                </div>
                            </div>
                            <div class="width-height" style="height: 82%">
                                <div id="myChart2" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="border-left-3">
                    <dv-border-box-7>
                        <div class="echarts1">
                            <div>
                                <p class="cont-top-bg">实时推荐</p>
                            </div>

                            <div class="swiper-data">
                                <dv-scroll-board :config="config3" style="width: 100%" />
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
            <!-- 中间 -->
            <div class="index-2">
                <div class="border-middle-1">
                    <dv-border-box-7>
                        <div class="middle-topOne">
                            <div class="middle-top">
                                <div class="middle-top-div">
                                    <div>
                                        <p class="middle-top-num">
                                            <animate-number from="1" :to="collectionAmount" :key="collectionAmount"
                                                :formatter="formatterd"></animate-number>万
                                        </p>
                                        <p class="middle-top-text">回款金额
                                            <span style="vertical-align: sub;cursor: pointer;" title="数据统计截止昨日，统计范围为已审核通过且到账时间为当前时间的业务相关-外部单位回款（不含内部往来款、非业务相关回款）">
                                                <svg t="1702981134529" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                                    xmlns="http://www.w3.org/2000/svg" p-id="4449" width="14" height="14"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <path
                                                        d="M512 128c212 0 384 172 384 384s-172 384-384 384-384-172-384-384 172-384 384-384m0-64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z"
                                                        p-id="4450" fill="#ffffff"></path>
                                                    <path d="M480 704h64v64h-64zM480 256h64v384h-64z" p-id="4451"
                                                        fill="#ffffff"></path>
                                                </svg>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="middle-top-div middle-line">
                                    <div>
                                        <p class="middle-top-num">
                                            <animate-number from="1" :to="branch" :key="branch"></animate-number>家
                                        </p>
                                        <p class="middle-top-text">分支机构</p>
                                    </div>
                                </div>
                                <div class="middle-top-div middle-line">
                                    <div>
                                        <p class="middle-top-num">
                                            <animate-number from="1" :to="peopleNum" :key="peopleNum"></animate-number>人
                                        </p>
                                        <p class="middle-top-text">员工人数</p>
                                    </div>
                                </div>
                                <div class="middle-top-div middle-line">
                                    <div>
                                        <p class="middle-top-num">
                                            <animate-number from="1" :to="customers" :key="customers"></animate-number>家
                                        </p>
                                        <p class="middle-top-text">服务客户
                                            <span style="vertical-align: sub;cursor: pointer;" title="数据统计截止昨日，当前时间合同生效和合同终止的客户总数">
                                                <svg t="1702981134529" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                                    xmlns="http://www.w3.org/2000/svg" p-id="4449" width="14" height="14"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <path
                                                        d="M512 128c212 0 384 172 384 384s-172 384-384 384-384-172-384-384 172-384 384-384m0-64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z"
                                                        p-id="4450" fill="#ffffff"></path>
                                                    <path d="M480 704h64v64h-64zM480 256h64v384h-64z" p-id="4451"
                                                        fill="#ffffff"></path>
                                                </svg>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="middle-top-div middle-line">
                                    <div>
                                        <p class="middle-top-num">
                                            <animate-number from="1" :to="candidate" :key="candidate"></animate-number>人
                                        </p>
                                        <p class="middle-top-text">交付人选
                                            <span style="vertical-align: sub;cursor: pointer;" title="数据统计截止昨日，绩效申请为当前时间且已审核通过的成功入职的人选数量">
                                                <svg t="1702981134529" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                                    xmlns="http://www.w3.org/2000/svg" p-id="4449" width="14" height="14"
                                                    xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <path
                                                        d="M512 128c212 0 384 172 384 384s-172 384-384 384-384-172-384-384 172-384 384-384m0-64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z"
                                                        p-id="4450" fill="#ffffff"></path>
                                                    <path d="M480 704h64v64h-64zM480 256h64v384h-64z" p-id="4451"
                                                        fill="#ffffff"></path>
                                                </svg>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="border-middle-2">
                    <dv-border-box-7>
                        <div class="echarts1" style="width: 98%; height: 95%; padding: 5px 8px 0">
                            <div style="width: 100%; height: 100%">
                                <p class="cont-top-bg6" style="line-height: 26px; height: 26px">
                                    公司分布及回款排行
                                </p>
                                <keep-alive>
                                    <indexMap @yearData="yearClick"></indexMap>
                                </keep-alive>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="border-middle-3" @mouseover="changIconsBlockPosition('enter', 3)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index">
                                <p class="cont-top-bg">
                                    月回款额
                                    <!-- <i style="font-size:12px;font-style:normal;">万</i>  -->
                                </p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsThr" class="cont-position" :timeArray="timerData"
                                        @chooseData="childByValue" :infoTitle="'月回款额'" @download="download"
                                        :idName="idName3" :stringPaintChart="childByValue"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.MONTH_COLLECTION" />
                                </div>
                            </div>
                            <div class="width-height">
                                <div id="repayment" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
            <!-- 右侧 -->
            <div class="index-3">
                <div class="border-right-1" @mouseover="changIconsBlockPosition('enter', 4)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index" style="height: 14%">
                                <p class="cont-top-bg">员工数据</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsFou" class="cont-position" :timeArray="timerData"
                                        @chooseData="childByValue" :infoTitle="'员工数据'" @download="download"
                                        :idName="idName4" :stringPaintChart="childByValue"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.EMPLOYEE_DATE" />
                                </div>
                            </div>
                            <div class="width-height">
                                <div id="staffData" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="border-right-2" @mouseover="changIconsBlockPosition('enter', 5)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index" style="height: 14%">
                                <p class="cont-top-bg6" style="line-height: 26px; height: 26px">
                                    回款客户等级分布
                                </p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsFiv" class="cont-position" :timeArray="timerData"
                                        @chooseData="childByValue" :infoTitle="'回款客户等级分布'" @download="download"
                                        :idName="idName5" :stringPaintChart="childByValue"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.COLLECTION_GRDE" />
                                </div>
                            </div>
                            <div class="width-height">
                                <div id="grade" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
                <div class="border-right-3" @mouseover="changIconsBlockPosition('enter', 6)"
                    @mouseleave="changIconsBlockPosition('out')">
                    <dv-border-box-7>
                        <div class="echarts1" style="height: 100%">
                            <div class="div-index" style="height: 14%">
                                <p class="cont-top-bg">简历数据</p>
                                <div class="icons-block">
                                    <iconsBlock ref="iconsSix" class="cont-position" :timeArray="timerData"
                                        @chooseData="childByValue" :infoTitle="'简历数据'" @download="download"
                                        :idName="idName6" :stringPaintChart="childByValue"
                                        @changeTextColor="changeTextColor" :details="COUNSTDATE.RESUME_Date" />
                                </div>
                            </div>
                            <div class="width-height">
                                <div id="resumeData" :style="{ width: '100%', height: '100%' }"></div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import indexMap from "./indexMap/indexMap.vue";
import iconsBlock from "./iconsBlock/index.vue";
import { exportImg } from "../../utils/downLoad.js";
import {
    GetIncomeClientGrade,
    GetRegionalClientGradeByDateRange,
    GetCustomerData,
    GetCustomerDataByDateRange,
    GetCandidateData,
    GetRegionalRecommendPersonByDateRange,
    GetMonthIncomeAmount,
    GetIncomeAmountByDateRange,
    GetMonthStaffData,
    GetStaffDataByDateRange,
    GetResumeReport,
    GetResumeReportByDateRange,
    GetRealTimeRecommendData,
    GetHomeHeadData,
} from "@/api/api";
import COUNSTDATE from "../../constants/index";
import { conversionUnit } from "../../utils/utils";

export default {
    components: {
        indexMap,
        iconsBlock,
    },
    data() {
        return {
            COUNSTDATE: COUNSTDATE,
            year: new Date().getFullYear(),
            idName1: "myChart",
            idName2: "myChart2",
            idName3: "repayment",
            idName4: "staffData",
            idName5: "grade",
            idName6: "resumeData",
            collectionAmount: 0,
            loadingShow: false,
            branch: 0,
            peopleNum: 0,
            customers: 0,
            candidate: 0,
            config3: {
                rowNum: 5, // 表行数
                headerHeight: 40,
                evenRowBGC: "none",
                oddRowBGC: "rgba(12,24,53,1)",
                waitTime: 2000, // 轮播时间间隔(ms)
                align: ["center", "center"],
                data: [],
            },
            arrData: [],
            topDataOneArr1: [],
            topDataOneArr2: [],
            topDataOneArr3: [],
            topDataOneArr4: [],
            isChildText: false,
            urlData: "",
            timerData: [],
            regionId: 0,
            companyId: 0,
            curDate: "",
            curTime: "",
            hoverTitle:"回款金额 ： 数据统计截止昨日，统计范围为已审核通过且到账时间为当前时间的业务相关-外部单位回款（不含内部往来款、非业务相关回款）"
        };
    },
    computed: {
        isTextColor() {
            return this.isChildText ? "#000" : "#fff";
        },
    },
    mounted() {

        this.onClick()
        this.twoClick()
        this.etCountDays()


        this.drawLine2();
        this.staffDataNum();
        this.gradeData();
        this.resumeDataNum();
        this.headData();
        this.topDataOne();
        this.middleDataTwo();
        this.recommendData();
    },
    methods: {
        etCountDays() {
            let curDate = new Date()
            let curMonth = curDate.getMonth()
            curDate.setMonth(curMonth + 1)
            curDate.setDate(0)
            /* 返回当月的天数和月份 */
            this.curDate = curDate.getDate()
            return { day: curDate.getDate(), month: curMonth + 1 }
        },
        childByValue(data, value, countryValue, companyValue, showNum) {
            if (data != undefined) {
                this.timerData = value
                var arr = value[1].substring(5, 7)
                if (arr == "01") {
                    this.curTime = "-31"
                } else if (arr == "02") {
                    this.curTime = "-28"
                } else if (arr == "03") {
                    this.curTime = "-31"
                } else if (arr == "04") {
                    this.curTime = "-30"
                } else if (arr == "05") {
                    this.curTime = "-31"
                } else if (arr == "06") {
                    this.curTime = "-30"
                } else if (arr == "07") {
                    this.curTime = "-31"
                } else if (arr == "08") {
                    this.curTime = "-31"
                } else if (arr == "09") {
                    this.curTime = "-30"
                } else if (arr == "10") {
                    this.curTime = "-31"
                } else if (arr == "11") {
                    this.curTime = "-30"
                } else if (arr == "12") {
                    this.curTime = "-31"
                }
                this.regionId = countryValue
                this.companyId = companyValue.value
            }
            if (data == undefined) {

                // if(this.idName1!=""){
                //     this.topDataOne1();
                // }
                // if(this.idName2!=""){
                //     this.drawLineTwo();
                // }
                // if(this.idName3!=""){
                //     this.middleDataTwoT();
                // }
                // if(this.idName4!=""){
                //     this.staffDataNumTwo();
                // }
                // if(this.idName5!=""){
                //     this.gradeDataTwo();
                // }
                // if(this.idName6!=""){
                //     this.resumeDataNumTwo();
                // }


            } else if (data == "myChart") {
                this.topDataOne1();
            } else if (data == "myChart2") {
                this.drawLineTwo();
            } else if (data == "staffData") {
                this.staffDataNumTwo();
            } else if (data == "repayment") {
                this.middleDataTwoT();
            } else if (data == "grade") {
                this.gradeDataTwo();
            } else if (data == "resumeData") {
                this.resumeDataNumTwo();
            }
        },

        //本季度开始
        onClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let m = 0;
            if (nowMonth < 3) {//012
                m = 0
            } else if (2 < nowMonth && nowMonth < 6) {//345
                m = 3
            } else if (5 < nowMonth && nowMonth < 8) {//678
                m = 6
            } else if (nowMonth > 8) { //9 10 11
                m = 9
            }
            let quarterStart = new Date(nowYear, m, 1)

            this.formatDate(quarterStart)
        },
        //本季度结束
        twoClick(picker) {
            var now = new Date(); // 当前日期
            var nowMonth = now.getMonth(); // 当前月
            var nowYear = now.getYear(); // 当前年
            nowYear += (nowYear < 2000) ? 1900 : 0;
            let i = 0;
            if (nowMonth < 3) {//012
                i = 3
            } else if (2 < nowMonth && nowMonth < 6) {//345
                i = 6
            } else if (5 < nowMonth && nowMonth < 8) {//678
                i = 9
            } else if (nowMonth > 8) { //9 10 11
                i = 0
            }

            let quarterEnd = new Date(nowYear, i, 1).getTime() - (60 * 60 * 24 * 1000)
            let aa = Date(parseInt(quarterEnd) * 1000).toLocaleString().replace(/:\d{1,2}$/, ' ')
            this.formatDate(new Date(aa))
        },

        formatDate(date) {
            var myyear = date.getFullYear();
            var mymonth = date.getMonth() + 1;
            var myweekday = date.getDate();
            if (mymonth < 10) {
                mymonth = "0" + mymonth;
            }
            if (myweekday < 10) {
                myweekday = "0" + myweekday;
            }
            this.timerData.push(myyear + "-" + mymonth)
            return (myyear + "-" + mymonth);
        },

        yearClick(data) {
            this.year = data;
            this.drawLine2();
            this.staffDataNum();
            this.gradeData();
            this.resumeDataNum();
            this.headData();
            this.topDataOne();
            this.middleDataTwo();
            this.recommendData();
        },
        //   数字动效
        formatterd(num) {
            return num.toFixed(2);
        },
        topDataOne1() {
            let params = {
                regionId: this.regionId,
                companyId: this.companyId,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] + this.curTime,
                ticket: this.urlData,
            };
            GetCustomerDataByDateRange(params).then((res) => {
                if (res.Status === 1) {
                    // 基于准备好的dom，初始化echarts实例
                    let myChart = this.$echarts.init(document.getElementById("myChart"));
                    var xData = [];
                    var yData1 = [];
                    var yData2 = [];
                    var yData3 = [];
                    res.Data.X.forEach((e) => {
                        xData.push(e);
                    });
                    res.Data.HuruClientCount.forEach((e) => {
                        yData1.push(e);
                    });
                    res.Data.QianyueClientCount.forEach((e) => {
                        yData2.push(e);
                    });
                    res.Data.WorkOrderCount.forEach((e) => {
                        yData3.push(e);
                    });

                    //   res.Data.forEach((e) => {
                    //     xData.push(e.Month + "月");
                    //     yData1.push(e.ClientCallCount);
                    //     yData2.push(e.ContractCount);
                    //     yData3.push(e.WorkOrderCount);
                    //   });

                    // 绘制图表
                    myChart.setOption({
                        title: {
                            top: "0",
                            left: "center",
                            //   text: "坐席电话统计",
                            textStyle: {
                                align: "center",
                                color: this.isTextColor,
                                fontSize: 22,
                            },
                        },
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "cross",
                            },
                        },
                        legend: {
                            //   x: "center",
                            //   y: "40px",
                            textStyle: {
                                color: this.isChildText ? "#000" : "#f2f2f2",
                                fontSize: 10,
                            },
                            bottom: "bottom",
                            icon: "roundRect",
                            itemWidth: 10, // 设置宽度
                            itemHeight: 2, // 设置高度
                            data: ["客戶呼入", "客戶签约", "工单数量"],
                        },
                        grid: {
                            right: "5%",
                            bottom: "10%",
                            left: "2%",
                            top: "5%",
                            containLabel: true,
                        },
                        xAxis: [
                            {
                                type: "category",
                                data: xData,
                                nameTextStyle: {
                                    color: this.isChildText ? "#000" : "#d4ffff",
                                },
                                axisLine: {
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true,
                                    interval: 0,
                                    rotate: -25, //代表逆时针旋转45度
                                    textStyle: {
                                        color: this.isTextColor,
                                        fontSize: 12,
                                    },
                                },
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                // name: "次数",
                                nameTextStyle: {
                                    color: this.isChildText ? "#000" : "#d4ffff",
                                },
                                position: "left",
                                axisLine: {
                                    lineStyle: {
                                        color: "#0B4CA9",
                                    },
                                },
                                splitLine: {
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    color: this.isChildText ? "#000" : "#d4ffff",
                                    fontSize: 12,
                                },
                            },
                        ],
                        series: [
                            {
                                name: "客戶呼入",
                                type: "line",
                                yAxisIndex: 0,
                                symbolSize: 4,
                                itemStyle: {
                                    normal: {
                                        color: "#1C82FF",
                                    },
                                },
                                data: yData1,
                            },
                            {
                                name: "客戶签约",
                                type: "line",
                                yAxisIndex: 0,
                                symbolSize: 4,
                                itemStyle: {
                                    normal: {
                                        color: "#FFDF38",
                                    },
                                },
                                data: yData2,
                            },
                            {
                                name: "工单数量",
                                type: "line",
                                yAxisIndex: 0,
                                symbolSize: 4,
                                itemStyle: {
                                    normal: {
                                        color: "#1FFD8A",
                                    },
                                },
                                data: yData3,
                            },
                        ],
                    });
                } else {
                    setTimeout(() => {
                        this.$message({
                            message: "您暂时没有权限访问BI！",
                            type: "warning",
                        });
                    }, 0);
                    setTimeout(() => {
                        window.location.href = "http://staff.risfond.com/signin.aspx";
                    }, 3500);
                }
            });
        },
        topDataOne() {
            let params = {
                year: this.year,
                ticket: this.urlData,
            };
            GetCustomerData(params).then((res) => {
                if (res.Status === 1) {
                    if (!this.topDataOneArr1.length) {
                        res.Data.forEach((e) => {
                            this.topDataOneArr1.push(e.Month + "月");
                            this.topDataOneArr2.push(e.ClientCallCount);
                            this.topDataOneArr3.push(e.ContractCount);
                            this.topDataOneArr4.push(e.WorkOrderCount);
                        });
                    }
                    // 基于准备好的dom，初始化echarts实例
                    let myChart = this.$echarts.init(document.getElementById("myChart"));
                    var xData = [];
                    var yData1 = [];
                    var yData2 = [];
                    var yData3 = [];
                    res.Data.forEach((e) => {
                        xData.push(e.Month + "月");
                        yData1.push(e.ClientCallCount);
                        yData2.push(e.ContractCount);
                        yData3.push(e.WorkOrderCount);
                    });

                    // 绘制图表
                    myChart.setOption({
                        title: {
                            top: "0",
                            left: "center",
                            //   text: "坐席电话统计",
                            textStyle: {
                                align: "center",
                                color: this.isTextColor,
                                fontSize: 22,
                            },
                        },
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "cross",
                            },
                        },
                        legend: {
                            //   x: "center",
                            //   y: "40px",
                            textStyle: {
                                color: this.isChildText ? "#000" : "#f2f2f2",
                                fontSize: 10,
                            },
                            bottom: "bottom",
                            icon: "roundRect",
                            itemWidth: 10, // 设置宽度
                            itemHeight: 2, // 设置高度
                            data: ["客戶呼入", "客戶签约", "工单数量"],
                        },
                        grid: {
                            right: "5%",
                            bottom: "10%",
                            left: "2%",
                            top: "5%",
                            containLabel: true,
                        },
                        xAxis: [
                            {
                                type: "category",
                                data: xData,
                                nameTextStyle: {
                                    color: this.isChildText ? "#000" : "#d4ffff",
                                },
                                axisLine: {
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true,
                                    interval: 0,
                                    rotate: -35, //代表逆时针旋转45度
                                    textStyle: {
                                        color: this.isTextColor,
                                        fontSize: 12,
                                    },
                                },
                            },
                        ],
                        yAxis: [
                            {
                                type: "value",
                                // name: "次数",
                                nameTextStyle: {
                                    color: this.isChildText ? "#000" : "#d4ffff",
                                },
                                position: "left",
                                axisLine: {
                                    lineStyle: {
                                        color: "#0B4CA9",
                                    },
                                },
                                splitLine: {
                                    lineStyle: {
                                        color: "#404666",
                                    },
                                },
                                axisLabel: {
                                    color: this.isChildText ? "#000" : "#d4ffff",
                                    fontSize: 12,
                                },
                            },
                        ],
                        series: [
                            {
                                name: "客戶呼入",
                                type: "line",
                                yAxisIndex: 0,
                                symbolSize: 4,
                                itemStyle: {
                                    normal: {
                                        color: "#1C82FF",
                                    },
                                },
                                data: yData1,
                            },
                            {
                                name: "客戶签约",
                                type: "line",
                                yAxisIndex: 0,
                                symbolSize: 4,
                                itemStyle: {
                                    normal: {
                                        color: "#FFDF38",
                                    },
                                },
                                data: yData2,
                            },
                            {
                                name: "工单数量",
                                type: "line",
                                yAxisIndex: 0,
                                symbolSize: 4,
                                itemStyle: {
                                    normal: {
                                        color: "#1FFD8A",
                                    },
                                },
                                data: yData3,
                            },
                        ],
                    });
                } else {
                    setTimeout(() => {
                        this.$message({
                            message: "您暂时没有权限访问BI！",
                            type: "warning",
                        });
                    }, 0);
                    setTimeout(() => {
                        window.location.href = "http://staff.risfond.com/signin.aspx";
                    }, 3500);
                }
            });
        },

        // 人选推荐
        drawLineTwo() {
            let params = {
                regionId: this.regionId,
                companyId: this.companyId,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] + this.curTime,
                ticket: this.urlData,
            };
            GetRegionalRecommendPersonByDateRange(params).then((res) => {
                var resDataOne = res.Data.RecommendCount;
                var resDataTwo = res.Data.InterViewCount;
                var resDataThree = res.Data.OfferCount;
                var resDataFour = res.Data.EntryCount;

                let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
                var getname = ["推给客户", "客户面试", "确认offer", "成功入职"];
                var getvalue = [resDataOne, resDataTwo, resDataThree, resDataFour];

                var data = [];
                for (var i = 0; i < getname.length; i++) {
                    data.push({
                        name: getname[i],
                        value: getvalue[i],
                    });
                }

                var percent = [
                    { value: resDataOne, name: "推给客户", num: 23334686 },
                    { value: resDataTwo, name: "客户面试", num: 756141 },
                    { value: resDataThree, name: "确认offer", num: 1447148 },
                    { value: resDataFour, name: "成功入职", num: 523833 },
                ];

                myChart2.setOption({
                    tooltip: {
                        trigger: "item",
                        formatter: "{b} : {c}",
                    },
                    grid: {
                        borderWidth: "0",
                        top: "5%",
                    },
                    legend: {
                        orient: "horizontal",
                        borderWidth: 0,
                        icon: "rect",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        },
                        x: "center",
                        bottom: "1%",
                        type: "scroll",
                        width: 250,
                        itemGap: 20,
                        itemWidth: 10,
                        itemHeight: 10,
                        data: ["推给客户", "客户面试", "确认offer", "成功入职"],
                        textStyle: {
                            fontSize: "12",
                            color: this.isTextColor,
                        },
                    },
                    calculable: false,
                    series: [
                        {
                            name: "",
                            type: "funnel",
                            left: "20%",
                            top: "5%",
                            bottom: "15%",
                            width: "40%",
                            gap: 3,
                            borderWidth: 0,
                            minSize: "10%",
                            maxSize: "100%",
                            label: {
                                show: false,
                            },
                            labelLine: {
                                length: 100,
                                show: false,
                            },
                            data: [
                                {
                                    value: resDataOne,
                                    name: "推给客户",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#1C82FF",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: resDataTwo,
                                    name: "客户面试",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#1FFD8A",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: resDataThree,
                                    name: "确认offer",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#00F2DD",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: resDataFour,
                                    name: "成功入职",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#8E5FFF",
                                        borderWidth: 0,
                                    },
                                },
                            ],
                        },
                        {
                            name: "",
                            type: "funnel",
                            gap: 70,
                            left: "1%",
                            label: {
                                normal: {
                                    //   formatter: "{d}%",
                                    formatter: function (value) {
                                        // return value.data.value +'%';
                                        if (value.data.name == "推给客户") {
                                            return "";
                                        } else if (value.data.name == "客户面试") {
                                            return (
                                                "推荐面试比:" +
                                                (
                                                    (res.Data.InterViewCount / res.Data.RecommendCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        } else if (value.data.name == "确认offer") {
                                            return (
                                                "面试offer比:" +
                                                (
                                                    (res.Data.OfferCount / res.Data.InterViewCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        } else if (value.data.name == "成功入职") {
                                            return (
                                                "offer入职比:" +
                                                (
                                                    (res.Data.EntryCount / res.Data.OfferCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        }
                                    },
                                    textStyle: {
                                        color: this.isTextColor,
                                        fontSize: 10,
                                    },
                                },
                            },

                            itemStyle: {
                                fontSize: 12,
                                normal: {
                                    color: "transparent",
                                    borderWidth: 0,
                                    opacity: 1,
                                },
                            },
                            data: percent,
                        },
                    ],
                });
            });
        },

        drawLine2() {
            let param = {
                year: this.year,
                ticket: this.urlData,
            };
            GetCandidateData(param).then((res) => {
                var resDataOne = res.Data.RecommendCount;
                var resDataTwo = res.Data.InterViewCount;
                var resDataThree = res.Data.OfferCount;
                var resDataFour = res.Data.EntryCount;

                let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
                var getname = ["推给客户", "客户面试", "确认offer", "成功入职"];
                var getvalue = [resDataOne, resDataTwo, resDataThree, resDataFour];

                var data = [];
                for (var i = 0; i < getname.length; i++) {
                    data.push({
                        name: getname[i],
                        value: getvalue[i],
                    });
                }

                var percent = [
                    { value: resDataOne, name: "推给客户", num: 23334686 },
                    { value: resDataTwo, name: "客户面试", num: 756141 },
                    { value: resDataThree, name: "确认offer", num: 1447148 },
                    { value: resDataFour, name: "成功入职", num: 523833 },
                ];

                myChart2.setOption({
                    tooltip: {
                        trigger: "item",
                        formatter: "{b} : {c}",
                    },
                    grid: {
                        borderWidth: "0",
                        top: "5%",
                    },
                    legend: {
                        orient: "horizontal",
                        borderWidth: 0,
                        icon: "rect",
                        pageIconColor: "#1C82FF",
                        pageTextStyle: {
                            color: "#fff", //翻页数字颜色
                        },
                        x: "center",
                        bottom: "1%",
                        type: "scroll",
                        width: 250,
                        itemGap: 20,
                        itemWidth: 10,
                        itemHeight: 10,
                        data: ["推给客户", "客户面试", "确认offer", "成功入职"],
                        textStyle: {
                            fontSize: "12",
                            color: this.isTextColor,
                        },
                    },
                    calculable: false,
                    series: [
                        {
                            name: "",
                            type: "funnel",
                            left: "20%",
                            top: "5%",
                            bottom: "15%",
                            width: "40%",
                            gap: 3,
                            borderWidth: 0,
                            minSize: "10%",
                            maxSize: "100%",
                            label: {
                                show: false,
                            },
                            labelLine: {
                                length: 100,
                                show: false,
                            },
                            data: [
                                {
                                    value: resDataOne,
                                    name: "推给客户",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#1C82FF",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: resDataTwo,
                                    name: "客户面试",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#1FFD8A",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: resDataThree,
                                    name: "确认offer",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#00F2DD",
                                        borderWidth: 0,
                                    },
                                },
                                {
                                    value: resDataFour,
                                    name: "成功入职",
                                    emphasis: {
                                        label: {
                                            show: false,
                                        },
                                    },
                                    itemStyle: {
                                        color: "#8E5FFF",
                                        borderWidth: 0,
                                    },
                                },
                            ],
                        },
                        {
                            name: "",
                            type: "funnel",
                            gap: 70,
                            left: "1%",
                            label: {
                                normal: {
                                    //   formatter: "{d}%",
                                    formatter: function (value) {
                                        // return value.data.value +'%';
                                        if (value.data.name == "推给客户") {
                                            return "";
                                        } else if (value.data.name == "客户面试") {
                                            return (
                                                "推荐面试比:" +
                                                (
                                                    (res.Data.InterViewCount / res.Data.RecommendCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        } else if (value.data.name == "确认offer") {
                                            return (
                                                "面试offer比:" +
                                                (
                                                    (res.Data.OfferCount / res.Data.InterViewCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        } else if (value.data.name == "成功入职") {
                                            return (
                                                "offer入职比:" +
                                                (
                                                    (res.Data.EntryCount / res.Data.OfferCount) *
                                                    100
                                                ).toFixed(2) +
                                                "%"
                                            );
                                        }
                                    },
                                    textStyle: {
                                        color: this.isTextColor,
                                        fontSize: 10,
                                    },
                                },
                            },

                            itemStyle: {
                                fontSize: 12,
                                normal: {
                                    color: "transparent",
                                    borderWidth: 0,
                                    opacity: 1,
                                },
                            },
                            data: percent,
                        },
                    ],
                });
            });
        },

        // 实时推荐
        recommendData() {
            let param = {
                size: 20,
                ticket: this.urlData,
            };
            GetRealTimeRecommendData(param).then((res) => {
                this.arrData = res.Data;
                this.config3.data = this.arrData;
                this.config3 = { ...this.config3 };
            });
        },
        // 中间顶部数据
        headData() {
            let param = {
                year: this.year,
                ticket: this.urlData,
            };
            GetHomeHeadData(param).then((res) => {
                this.collectionAmount = conversionUnit(res.Data.IncomeAmount);
                this.branch = res.Data.CompanyCount;
                this.peopleNum = res.Data.StaffCount;
                this.customers = res.Data.ClientCount;
                this.candidate = res.Data.EntryCount;
            });
        },
        // 月回款额
        middleDataTwoT() {
            let params = {
                regionId: this.regionId,
                companyId: this.companyId,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] + this.curTime,
                ticket: this.urlData,
            };
            GetIncomeAmountByDateRange(params).then((res) => {
                var mount = [];
                var data = [];
                res.Data.forEach((e) => {
                    mount.push(e.RecordTimeText + "月");
                    data.push(e.IncomeAmount);
                });

                let repayment = this.$echarts.init(
                    document.getElementById("repayment")
                );

                repayment.setOption({
                    xAxis: {
                        type: "category",
                        data: mount,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: this.isTextColor, //这里用参数代替了
                            },
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            show: true,
                            interval: 0,
                            rotate: 25, //代表逆时针旋转45度
                            textStyle: {
                                color: this.isTextColor, //这里用参数代替了
                                fontSize: "10px",
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ["#404666"],
                                width: 1,
                                type: "solid",
                            },
                        },
                    },

                    grid: {
                        right: "5%",
                        bottom: "5%",
                        left: "2%",
                        top: "5%",
                        containLabel: true,
                    },

                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985",
                            },
                        },
                    },
                    series: [
                        {
                            data: data,
                            barWidth: 25,
                            type: "bar",
                            color: "#1C82FF",
                        },
                    ],
                });
            });
        },
        middleDataTwo() {
            let param = {
                year: this.year,
                ticket: this.urlData,
            };
            GetMonthIncomeAmount(param).then((res) => {
                var mount = [];
                var data = [];
                res.Data.forEach((e) => {
                    mount.push(e.Month + "月");
                    data.push((e.IncomeAmount / 10000).toFixed(2));
                });

                let repayment = this.$echarts.init(
                    document.getElementById("repayment")
                );

                repayment.setOption({
                    xAxis: {
                        type: "category",
                        data: mount,
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: this.isTextColor, //这里用参数代替了
                            },
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            show: true,
                            interval: 0,
                            rotate: 25, //代表逆时针旋转45度
                            textStyle: {
                                color: this.isTextColor, //这里用参数代替了
                                fontSize: "10px",
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ["#404666"],
                                width: 1,
                                type: "solid",
                            },
                        },
                    },

                    grid: {
                        right: "5%",
                        bottom: "5%",
                        left: "2%",
                        top: "5%",
                        containLabel: true,
                    },

                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985",
                            },
                        },
                    },
                    series: [
                        {
                            data: data,
                            barWidth: 25,
                            type: "bar",
                            color: "#1C82FF",
                        },
                    ],
                });
            });
        },

        // 员工数据
        staffDataNumTwo() {
            let params = {
                regionId: this.regionId,
                companyId: this.companyId,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] + this.curTime,
                ticket: this.urlData,
            };

            GetStaffDataByDateRange(params).then((res) => {
                let staffData = this.$echarts.init(
                    document.getElementById("staffData")
                );
                var xData = [];
                var yData1 = [];
                var yData2 = [];
                var yData3 = [];
                res.Data.X.forEach((e) => {
                    xData.push(e + "月");
                });
                res.Data.AllStaffCount.forEach((e) => {
                    yData1.push(e);
                });
                res.Data.ZaizhiCount.forEach((e) => {
                    yData2.push(e);
                });
                res.Data.LizhiCount.forEach((e) => {
                    yData3.push(e);
                });

                staffData.setOption({
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                        },
                    },
                    legend: {
                        //   x: "center",
                        //   y: "40px",
                        textStyle: {
                            color: this.isChildText ? "#000" : "#f2f2f2",
                            fontSize: 10,
                        },
                        bottom: "bottom",
                        icon: "roundRect",
                        itemWidth: 10, // 设置宽度
                        itemHeight: 2, // 设置高度
                        data: ["员工总数", "入职数", "离职"],
                    },
                    grid: {
                        right: "6%",
                        bottom: "12%",
                        left: "2%",
                        top: "5%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: xData,
                            // name: "时间",
                            nameTextStyle: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                show: true,
                                interval: 0,
                                rotate: -35, //代表逆时针旋转45度
                                textStyle: {
                                    color: this.isTextColor,
                                    fontSize: 12,
                                },
                                //interval:0,
                                //rotate:30
                            },
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            // name: "次数",
                            nameTextStyle: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                            },
                            position: "left",
                            axisLine: {
                                lineStyle: {
                                    color: this.isChildText ? "#000" : "#0B4CA9",
                                },
                            },
                            splitLine: {
                                lineStyle: {
                                    color: this.isChildText ? "#000" : "#404666",
                                },
                            },
                            axisLabel: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                                fontSize: 12,
                            },
                        },
                    ],
                    series: [
                        {
                            name: "员工总数",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 4,
                            itemStyle: {
                                normal: {
                                    color: "#1C82FF",
                                },
                            },
                            data: yData1,
                        },
                        {
                            name: "入职数",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 4,
                            itemStyle: {
                                normal: {
                                    color: "#FFDF38",
                                },
                            },
                            data: yData2,
                        },
                        {
                            name: "离职",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 4,
                            itemStyle: {
                                normal: {
                                    color: "#1FFD8A",
                                },
                            },
                            data: yData3,
                        },
                    ],
                });
            });
        },
        staffDataNum() {
            let param = {
                year: this.year,
                ticket: this.urlData,
            };
            GetMonthStaffData(param).then((res) => {
                let staffData = this.$echarts.init(
                    document.getElementById("staffData")
                );
                var xData = [];
                var yData1 = [];
                var yData2 = [];
                var yData3 = [];
                res.Data.forEach((e) => {
                    xData.push(e.Month + "月");
                    yData1.push(e.StaffCount);
                    yData2.push(e.StaffEntryCount);
                    yData3.push(e.StaffLeaveCount);
                });

                staffData.setOption({
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                        },
                    },
                    legend: {
                        //   x: "center",
                        //   y: "40px",
                        textStyle: {
                            color: this.isChildText ? "#000" : "#f2f2f2",
                            fontSize: 10,
                        },
                        bottom: "bottom",
                        icon: "roundRect",
                        itemWidth: 10, // 设置宽度
                        itemHeight: 2, // 设置高度
                        data: ["员工总数", "入职数", "离职"],
                    },
                    grid: {
                        right: "6%",
                        bottom: "12%",
                        left: "2%",
                        top: "5%",
                        containLabel: true,
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: xData,
                            // name: "时间",
                            nameTextStyle: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#404666",
                                },
                            },
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                show: true,
                                interval: 0,
                                rotate: -35, //代表逆时针旋转45度
                                textStyle: {
                                    color: this.isTextColor,
                                    fontSize: 12,
                                },
                                //interval:0,
                                //rotate:30
                            },
                        },
                    ],
                    yAxis: [
                        {
                            type: "value",
                            // name: "次数",
                            nameTextStyle: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                            },
                            position: "left",
                            axisLine: {
                                lineStyle: {
                                    color: this.isChildText ? "#000" : "#0B4CA9",
                                },
                            },
                            splitLine: {
                                lineStyle: {
                                    color: this.isChildText ? "#000" : "#404666",
                                },
                            },
                            axisLabel: {
                                color: this.isChildText ? "#000" : "#d4ffff",
                                fontSize: 12,
                            },
                        },
                    ],
                    series: [
                        {
                            name: "员工总数",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 4,
                            itemStyle: {
                                normal: {
                                    color: "#1C82FF",
                                },
                            },
                            data: yData1,
                        },
                        {
                            name: "入职数",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 4,
                            itemStyle: {
                                normal: {
                                    color: "#FFDF38",
                                },
                            },
                            data: yData2,
                        },
                        {
                            name: "离职",
                            type: "line",
                            yAxisIndex: 0,
                            symbolSize: 4,
                            itemStyle: {
                                normal: {
                                    color: "#1FFD8A",
                                },
                            },
                            data: yData3,
                        },
                    ],
                });
            });
        },
        // 回款客户等级分布
        gradeDataTwo() {
            let params = {
                regionId: this.regionId,
                companyId: this.companyId,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] + this.curTime,
                ticket: this.urlData,
            };

            GetRegionalClientGradeByDateRange(params).then((res) => {
                let color = ["#1C82FF", "#8993FF", "#1FFD8A", "#F8D135"];
                let echartData = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.ClientGrade,
                        value: e.ClientCount,
                    };
                    echartData.push(item);
                });

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };

                let grade = this.$echarts.init(document.getElementById("grade"));
                grade.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        top: "5%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "5%",
                        itemWidth: 12,
                        itemHeight: 12,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["55%", "47%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    fontSize: "12",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                });
            });
        },
        gradeData() {
            let param = {
                year: this.year,
                ticket: this.urlData,
            };
            GetIncomeClientGrade(param).then((res) => {
                let color = ["#1C82FF", "#8993FF", "#1FFD8A", "#F8D135"];
                let echartData = [];
                res.Data.forEach((e) => {
                    const item = {
                        name: e.ClientGrade,
                        value: e.ClientGradeCount,
                    };
                    echartData.push(item);
                });

                let formatNumber = function (num) {
                    let reg = /(?=(\B)(\d{3})+$)/g;
                    return num.toString().replace(reg, ",");
                };

                let grade = this.$echarts.init(document.getElementById("grade"));
                grade.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        top: "5%",
                        containLabel: true,
                    },
                    color: color,
                    tooltip: {
                        trigger: "item",
                        formatter: "{d}%",
                    },
                    legend: {
                        orient: "horizontal",
                        icon: "rect",
                        x: "center",
                        bottom: "5%",
                        itemWidth: 12,
                        itemHeight: 12,
                        align: "left",
                        textStyle: {
                            color: this.isTextColor,
                            rich: {
                                name: {
                                    fontSize: 12,
                                    color: this.isTextColor,
                                },
                            },
                        },
                        // data: legendName
                    },
                    series: [
                        {
                            type: "pie",
                            radius: ["45%", "60%"],
                            center: ["55%", "47%"],
                            data: echartData,
                            hoverAnimation: false,
                            itemStyle: {
                                normal: {
                                    borderWidth: 1,
                                },
                            },
                            label: {
                                normal: {
                                    formatter: "{d}%",
                                    fontSize: "12",
                                    borderWidth: 0,
                                    color: this.isTextColor,
                                },
                            },
                        },
                    ],
                });
            });
        },

        // 简历数据
        resumeDataNumTwo() {
            let params = {
                regionId: this.regionId,
                companyId: this.companyId,
                DateFrom: this.timerData[0] + "-01",
                DateTo: this.timerData[1] + this.curTime,
                ticket: this.urlData,
            };
            GetResumeReportByDateRange(params).then((res) => {
                let resumeData = this.$echarts.init(
                    document.getElementById("resumeData")
                );
                var data = {
                    area: [
                        "1月",
                        "2月",
                        "3月",
                        "4月",
                        "5月",
                        "6月",
                        "7月",
                        "8月",
                        "9月",
                        "10月",
                        "11月",
                        "12月",
                    ],
                    legend: ["会员注册简历", "员工录入简历"],
                    data: [res.Data.MemberResumeCount, res.Data.NotMemberResumeCount],
                };

                var colors = ["#1C82FF", "#1FFD8A"];
                var option = {
                    color: colors,
                    legend: {
                        bottom: "2%",
                        left: "center",
                        itemWidth: 10,
                        itemHeight: 10,
                        // padding: [5, 10],
                        textStyle: {
                            fontSize: 10,
                            color: "#96A4F4",
                            padding: [3, 0, 0, 0],
                        },
                        data: data.legend,
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "15%",
                        top: "5%",
                        containLabel: true,
                    },
                    xAxis: {
                        type: "category",
                        axisLabel: {
                            interval: 0,
                            color: "#96A4F4",
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#96A4F4",
                            },
                            width: 5,
                        },
                        axisTick: {
                            show: false,
                        },
                        data: data.area,
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            color: "#96A4F4",
                            interval: 0,
                            rotate: 25, //代表逆时针旋转45度
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#96A4F4",
                            },
                            width: 5,
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            lineStyle: {
                                color: "rgba(150, 164, 244, 0.3)",
                            },
                        },
                    },
                    series: [],
                };
                for (var i = 0; i < data.legend.length; i++) {
                    option.series.push({
                        name: data.legend[i],
                        type: "bar",
                        stack: "总量",
                        barWidth: "30%",
                        label: {
                            show: false,
                            position: "insideRight",
                        },
                        data: data.data[i],
                    });
                }
                resumeData.setOption(option);
            });
        },
        resumeDataNum() {
            let param = {
                year: this.year,
                ticket: this.urlData,
            };
            GetResumeReport(param).then((res) => {
                let resumeData = this.$echarts.init(
                    document.getElementById("resumeData")
                );
                var data = {
                    area: [
                        "1月",
                        "2月",
                        "3月",
                        "4月",
                        "5月",
                        "6月",
                        "7月",
                        "8月",
                        "9月",
                        "10月",
                        "11月",
                        "12月",
                    ],
                    legend: ["会员注册简历", "员工录入简历"],
                    data: [res.Data.MemberResumeCount, res.Data.NotMemberResumeCount],
                };

                var colors = ["#1C82FF", "#1FFD8A"];
                var option = {
                    color: colors,
                    legend: {
                        bottom: "2%",
                        left: "center",
                        itemWidth: 10,
                        itemHeight: 10,
                        // padding: [5, 10],
                        textStyle: {
                            fontSize: 10,
                            color: "#96A4F4",
                            padding: [3, 0, 0, 0],
                        },
                        data: data.legend,
                    },
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "15%",
                        top: "5%",
                        containLabel: true,
                    },
                    xAxis: {
                        type: "category",
                        axisLabel: {
                            interval: 0,
                            color: "#96A4F4",
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#96A4F4",
                            },
                            width: 5,
                        },
                        axisTick: {
                            show: false,
                        },
                        data: data.area,
                    },
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                        },
                    },
                    yAxis: {
                        type: "value",
                        axisLabel: {
                            color: "#96A4F4",
                            interval: 0,
                            rotate: 25, //代表逆时针旋转45度
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#96A4F4",
                            },
                            width: 5,
                        },
                        axisTick: {
                            show: false,
                        },
                        splitLine: {
                            lineStyle: {
                                color: "rgba(150, 164, 244, 0.3)",
                            },
                        },
                    },
                    series: [],
                };
                for (var i = 0; i < data.legend.length; i++) {
                    option.series.push({
                        name: data.legend[i],
                        type: "bar",
                        stack: "总量",
                        barWidth: "30%",
                        label: {
                            show: false,
                            position: "insideRight",
                        },
                        data: data.data[i],
                    });
                }
                resumeData.setOption(option);
            });
        },
        changIconsBlockPosition(str, index) {
            if (str === "enter") {
                if (index === 1) {
                    this.$refs.iconsFir.$el.classList.add("cont-position-act");
                }
                if (index == 2) {
                    this.$refs.iconsSec.$el.classList.add("cont-position-act");
                }
                if (index == 3) {
                    this.$refs.iconsThr.$el.classList.add("cont-position-act");
                }
                if (index == 4) {
                    this.$refs.iconsFou.$el.classList.add("cont-position-act");
                }
                if (index == 5) {
                    this.$refs.iconsFiv.$el.classList.add("cont-position-act");
                }
                if (index == 6) {
                    this.$refs.iconsSix.$el.classList.add("cont-position-act");
                }
            } else {
                this.$refs.iconsFir.$el.classList.remove("cont-position-act");
                this.$refs.iconsSec.$el.classList.remove("cont-position-act");
                this.$refs.iconsThr.$el.classList.remove("cont-position-act");
                this.$refs.iconsFou.$el.classList.remove("cont-position-act");
                this.$refs.iconsFiv.$el.classList.remove("cont-position-act");
                this.$refs.iconsSix.$el.classList.remove("cont-position-act");
            }
        },
        changeTextColor(status) {
            this.isChildText = status;
        },
        download(idName, imgName = "chart") {
            exportImg(idName, imgName);
        },
    },
    created() {
        var urlData1 = this.$route.query.ticket; //url.substring(url.lastIndexOf('ticket') + 7);
        if (urlData1 != "" && urlData1 != undefined && urlData1 != null) {
            sessionStorage.setItem("urlData", urlData1);
        }
        this.urlData = sessionStorage.getItem("urlData");

        // Vue.prototype.$urlData=sessionStorage.getItem("urlData")
    },
};
</script>

<style scoped>
.hoverTitle {
    white-space: pre-wrap; /* 实现开启单词折行并自动折行 */
  }
  .hoverTitle:after {
    content: '\n'; /* 添加伪字符，在此位置添加换行符，与实体字符相同 */
    white-space: pre; /* 告诉浏览器在伪字符之后不要自动折行 */
  }
.index {
    width: 100vw;
    height: 100vh;
    display: flex;
}

.index-cont {
    width: 100%;
    height: 100%;
    padding: 19px 32px 31px;
    display: flex;
    justify-content: space-between;
}

.div-index {
    height: 14%;
    /* position: absolute; */
    width: 100%;
    /* z-index: 999; */
}

.index-1 {
    width: 25%;
    height: 100%;
    /* background: chartreuse; */
}

.index-2 {
    flex: 1;
    width: 50%;
    margin: 0 26px;
    height: 100%;
    /* background:chocolate ; */
}

.index-3 {
    width: 25%;
    height: 100%;
    /* background: chartreuse; */
}

.border-left-1,
.border-right-1 {
    width: 100%;
    height: 30%;
}

.border-left-2,
.border-right-2 {
    margin: 10px 0;
    width: 100%;
    height: 30%;
}

.border-left-3,
.border-right-3 {
    width: 100%;
    height: 25%;
}

.border-middle-1 {
    width: 100%;
    height: 10%;
}

.border-middle-2 {
    width: 100%;
    height: 50%;
    margin: 10px 0;
}

.middle-topOne {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.border-middle-3 {
    width: 100%;
    height: 25%;
}

.echarts1 {
    color: #fff;
    padding: 16px 8px;
}

>>>.dv-border-box-7 .dv-border-svg-container>polyline {
    stroke: #1eb0fc;
}

>>>.dv-border-box-7 {
    box-shadow: 0px 0px 10px 0px #7580be inset !important;
}

>>>.dv-border-box-7:hover {
    box-shadow: 0px 0px 10px 0px #ffdf38 inset !important;
}

>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(2),
>>>.dv-border-box-7 .dv-border-svg-container>polyline:nth-child(4) {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-5 {
    display: none !important;
}

>>>.dv-border-box-7 .dv-bb7-line-width-2 {
    stroke-width: 2;
}

>>>.dv-border-box-7:hover .right-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-top polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .right-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

>>>.dv-border-box-7:hover .left-bottom polygon {
    stroke: #ffdf38;
    fill: #ffdf38;
}

.cont-top-bg {
    background: url(../../assets/img/cont-bg-four.png) no-repeat;
}

.cont-top-bg6 {
    background: url(../../assets/img/cont-bg-eight.png) no-repeat;
}

.cont-top-bg6,
.cont-top-bg {
    padding: 5px 92px 5px 12px;
    letter-spacing: 1px;
    font-size: 16px;
    /* min-width: 92px; */
    background-size: 100%;
    position: absolute;
    /* text-align: center; */
    background-position: center;
    height: 26px;
    line-height: 26px;
}

.swiper-data {
    margin-top: 45px;
    width: 100%;
    height: 170px;
}

.middle-top {
    width: 100%;
    display: flex;
    padding: 5px 0;
}

.middle-top-div {
    width: 20%;
    text-align: center;
    display: flex;
    justify-content: center;
}

.middle-top-num {
    font-weight: 600;
    color: #ffdf38;
    line-height: 30px;
    letter-spacing: 1px;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    width: 172px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    word-break: break-all;
}

.middle-top-text {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    letter-spacing: 1px;
}

.middle-line {
    border-left: 1px solid #404666;
}

.width-height {
    width: 96%;
    height: 80%;
    position: absolute;
}

.middle-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
}

.cont-position {
    position: relative;
    left: 112px;
    transition: all 0.3s linear;
}

.cont-position-act {
    left: 0px;
}

.icons-block {
    overflow: hidden;
    margin-right: 6px;
    padding: 4px 2px;
    position: absolute;
    right: 8px;
    /* z-index: 99999; */
}

@media (min-width: 1279px) and (max-width: 1365px) {
    .index {
        height: 90vh;
    }

    .index-2 {
        margin: 0 16px;
    }

    .border-left-1,
    .border-right-1 {
        height: 33%;
    }

    .border-left-2,
    .border-right-2 {
        height: 33%;
    }

    .border-left-3,
    .border-right-3 {
        height: 30%;
    }

    .border-middle-2 {
        height: 56%;
    }

    .border-middle-3 {
        height: 30%;
    }

    .index-cont {
        padding: 15px 15px;
    }

    .swiper-data {
        height: 77%;
    }

    .echarts1 {
        width: 98%;
        height: 100%;
        overflow: hidden;
        padding: 0px 3px 5px;
    }

    .middle-top-num {
        font-size: 16px;
    }

    .width-height {
        height: 86%;
    }

    .middle-top-text {
        font-size: 12px;
    }

    .cont-top-bg6,
    .cont-top-bg {
        font-size: 12px;
    }

    .cont-top-bg6,
    .cont-top-bg {
        margin-top: 10px;
        margin-left: 5px;
        padding: 0 70px 0 12px;
    }
}

>>>.dv-scroll-board .rows .ceil {
    font-size: 12px !important;
}

@media (max-width: 1300px) {
    .middle-top-num {
        width: 100px !important;
    }
}</style>


// WEBPACK FOOTER //
// src/components/dataChart/index.vue